<template>
  <div class="auth-layout">
    <div class="auth-layout__content">
      <RouterLink to="/" class="auth-layout__logo-link" aria-label="Visit homepage">
        <img src="/logo.png" alt="VALT" class="auth-layout__logo" />
      </RouterLink>
      <h1 class="auth-layout__title">Welcome to valtOS</h1>
      <p class="auth-layout__subtitle">Valt OS — Fleet Management, Simplified</p>
      <RouterView />
    </div>
    <footer class="auth-layout__footer">© {{ currentYear }} VALT. All rights reserved.</footer>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>
